import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import HotDealsCard from "./HotDealsCard";
import "./index.css";

const HotDeals = ({ t, vendor_name }) => {
  const [newArrivalProducts, setnewArrivalProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/hot-deal?vendor_name=${vendor_name}`)
      .then((response) => response.json())
      .then((data) => { 
        setnewArrivalProducts(data); 
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [vendor_name]);

  const LoadingSkeleton = () => (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p className="loading-text">{t("Loading") || "Loading awesome deals..."}</p>
      </div>
    </div>
  );

  const EmptyState = () => (
    <div className="empty-state">
      <div className="empty-icon">🔥</div>
      <h3>{t("NoHotDeals") || "No Hot Deals Available"}</h3>
      <p>{t("CheckBackLater") || "Check back later for amazing deals!"}</p>
    </div>
  );

  let productsToShow;
  if (loading) {
    productsToShow = <LoadingSkeleton />;
  } else if (newArrivalProducts.length) {
    productsToShow = (
      <div className="products-grid">
        {newArrivalProducts.slice(0, 20).map((product, index) => (
          <div key={product.id || index} className="product-item">
            <HotDealsCard
              productObj={product}
              title={product.name}
              price={`৳${product.price}`}
              image={product.photo}
              t={t}
            />
          </div>
        ))}
      </div>
    );
  } else {
    productsToShow = <EmptyState />;
  }

  return (
    <section className="hot-deals-section">
      <div className="container">
        <div className="section-header">
          <div className="header-content">
            <div className="fire-icon">🔥</div>
            <div className="header-text">
              <h1 className="section-title">
                {t("HotDeals") || "Hot Deals"}
                <span className="deals-count">
                  {!loading && newArrivalProducts.length > 0 && 
                    `(${newArrivalProducts.length})`
                  }
                </span>
              </h1>
              <p className="section-subtitle">
                {t("LimitedTimeOffers") || "Limited time offers - Don't miss out!"}
              </p>
            </div>
          </div>
          <div className="header-decoration">
            <div className="decoration-line"></div>
            <div className="decoration-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        
        <div className="deals-content">
          {productsToShow}
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    vendor_name: state.globalState.selectedProductVendorName,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(HotDeals);